<div
  (click)="select()"
  class="relative rounded-lg px-3 py-2 cursor-pointer border transition-all duration-150
    {{
       isSelected()              ? 'border-1 border-primary-500 bg-primary-50' :
                                   'border border-[var(--color-gray-200)] bg-[var(--color-white)] hover:border-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)]' }}"
>
  <!-- Title row -->
  <div class="flex items-start justify-between gap-2">
    <span class="text-sm font-medium leading-snug"><span *dev>{{ todo().id }}  -</span>{{ todo().title }}</span>

    @if (isDone()) {
      <span class="pi pi-check-circle shrink-0 text-emerald-500 mt-0.5"></span>
    }
  </div>

  <!-- Concern row -->
  @if (todo().concern) {
    <div class="flex items-center gap-1 mt-1 text-xs text-[var(--p-surface-500)]">
      <span class="pi pi-building leading-none"></span>
      <span class="truncate">{{ todo().concern!.fullName }}</span>
    </div>
  }
</div>

@if (todo().children.length) {
  <div (click)="$event.stopPropagation()" class="pl-4 flex flex-col gap-1 mt-1">
    @for (child of todo().children; track child.id) {
      <elcia-todo-picker-item (onTodoSelect)="this.onTodoSelect.emit($event)" [control]="control()" [todo]="child"/>
    }
  </div>
}
